module.exports = __webpack_public_path__ + "static/media/serial_double.8c750a9c.jpg";